const { userAgent } = navigator;
const isIOS = /iphone|ipad|itouch|ipod/i.test(userAgent);
const isAndroid = /android/i.test(userAgent);
const isMgtvApp = /ImgoTV/i.test(userAgent);

export default {
  isWeixin: /MicroMessenger/i.test(userAgent) || /weixin/.test(userAgent),
  isWeiBo: /WeiBo/i.test(userAgent),
  isQQ: /QQ/i.test(userAgent),
  isMgtvApp,
  isIOS,
  isAndroid,
  isPc: !isIOS && !isAndroid,
  isMobile: (!isMgtvApp) && (isIOS || isAndroid),
  isLocal: process.env.VUE_APP_ENV === 'local',
  isDev: process.env.VUE_APP_ENV === 'development',
  isPre: process.env.VUE_APP_ENV === 'pre',
};

